module.exports = __webpack_public_path__ + "static/media/nSyWuw9GLg.d27d9fd9.jpg";